export const DATE_FORMAT = 'MMM DD, YYYY, hh:mm A';
export const SCHEDULE_DATE_FORMAT = 'YYYY-MM-DD';
export const ABBREVIATED_DATE_FORMAT = 'MMM DD, YYYY';
export const ABBREVIATED_TIME_FORMAT = 'h:mm A';
export const MIN_LENGTH_TO_SEARCH = 3;

export const SYSTEM_TAG_FOR_ALL_ID = '__SYSTEM__FOR_ALL__';

export const REGEX_SYMBOLS = /[\p{P}\p{S}]/gu;
export const REGEX_SPECIFIC_SYMBOLS = /[.*+?^${}()|[\]\\]/g;

export enum DURATIONS {
  MINUTES_1 = 1000 * 60,
  MINUTES_5 = 1000 * 60 * 5,
}
